import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as DTO from '../service/DTOs';
import { AppState } from '../service/AppState';
import { DoMComponent } from './DoM';
import { MyOrdersComponent } from './MyOrders';
import { MyDealsComponent } from './MyDeals';
import { NewOrderComponent } from './OrderEntrance';
import { DoMRowDetailsComponent } from './DoMRowDetails';
import * as API from '../service/apisvc';
import * as State from '../service/AppState';
import * as Session from '../service/Session';


import { SpinnerBlock } from './shared/effects/Spinners'
const iconSpinner = <SpinnerBlock />

import * as TF from '../service/tradeflow';

import 'isomorphic-fetch';

export interface MainFrameState {
    instruments: DTO.InstrumentHead[],
    currencies: DTO.Currency[],
    durations: DTO.Duration[],
    appstate?: AppState,
    sysavail: DTO.SystemOperationAvailabilityDto,
    loading?: boolean;
}

type MainFrameProps = MainFrameState & { xsrfToken?: string } & RouteComponentProps<{}>;

const initialstate: MainFrameState = {
    instruments: [],
    currencies: [],
    durations: [],
    appstate: undefined,
    sysavail: State.default.sysavail,
    loading: true
}



export class MainFrameComponent extends React.Component<MainFrameProps, MainFrameState> {
    node_hb: HTMLDivElement | null;
    constructor(props: MainFrameProps) {
        super(props);
        this.node_hb = null;
        this.state = {
            ...initialstate, ...{ instruments: props.instruments, appstate: props.appstate }
        };



        fetch(API.apiUrl(API.API_CONFIG_URL), {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...{ 'X-XSRF-TOKEN': props.xsrfToken || '' },
                ...API.authHeader()
            })
        })
            .then(response => {
                if (response.ok) {
                    return response.json() as Promise<DTO.AppConfig>
                } else {
                    var cmd_hdr = response.headers.get(API._API_CMD_HEADER);

                    if (cmd_hdr) {
                        TF.PublishSysCommand(cmd_hdr);
                    }
                    var error = new Error(response.statusText);
                    throw error;
                }
            }
            )
            .then(data => {
                this.setState({ instruments: data.instruments, currencies: data.currencies, durations: data.durations, loading: false });

                TF.PublishCommand('COMMAND.SYS.UpdateConfig', data);
            })
            .catch(reason => {
                console.log(reason);
            })
            ;

    }

    processSysAvail(data: DTO.SystemOperationAvailabilityDto) {
        if (this.refs.cmpNodeRef) {
            this.setState({
                sysavail: data
            });
        }

        return { return: 0 };
    }


    componentDidMount() {
        TF.DataProcessBinding(this, { type: 'SYS.updatesysavail', delegate: this.processSysAvail });

        //if (window.tradeflow_binddata !== undefined) {
        //    console.log(this.setApiHeaderResponse);

        //    window.tradeflow_binddata(TF.TradeflowData.heartbeat, this, this.setApiHeaderResponse);
        //}


        //if (window.test !== undefined) {
        //    window.test();
        //}

        //const testfn = window.test(); // eslint-disable-line        
        //tradeflow.bind();

        //let _user = API.currentUser();
        //this.setState({ appstate: { ...this.state.appstate, user: _user} });
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(nextProps: MainFrameProps) {
        this.setState({ appstate: nextProps.appstate });
    }

    public render() {
        //console.log('this.state.appstate.dsctx.instrumentsDS');
        //console.log(this.state.appstate ? this.state.appstate.dsctx.instrumentsDS : '');


        //let s = State.default.dsctx.instrumentsDS.instruments.filter((obj) => { return obj.fiid ==  })
        let DoMcontents = this.state.loading
            ? <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
            : this.renderInstruments(this.state.instruments,
                this.state.appstate ? this.state.appstate.dsctx.instrumentsDS : State.default.dsctx.instrumentsDS,
                //this.state.appstate ? this.state.appstate.sysavail.instruments : State.default.sysavail.instruments
                this.state.sysavail.tradesession
            );

        let formscontents = this.state.loading || !this.state.appstate
            ? <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
            : MainFrameComponent.renderForms(this.state.appstate, this.state.instruments, this.state.currencies, this.state.durations, this.state.sysavail.tradesession);

        let myOrders = this.state.loading
            ? <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
            : MainFrameComponent.renderMyOrders({ ordbook_records: [] }, this.state.appstate ? this.state.appstate.dsctx.myOrdersDS : { periodFilter: { isCurrentPeriod: true }, attributesFilter: { isMyOwnOnly: true } }, this.state.sysavail.tradesession);

        let myDeals = this.state.loading
            ? <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
            : MainFrameComponent.renderMyDeals({ ordbook_records: [] }, this.state.appstate ? this.state.appstate.dsctx.myDealsDS : { periodFilter: { isCurrentPeriod: true }, attributesFilter: { isMyOwnOnly: true } });

        //className='container'
        return <div ref="cmpNodeRef" className={'otc-trade'}>
            <div className='row' id='body_row'>
                <div className='col-sm-7 col-md-8'>
                    {DoMcontents}
                </div>
                <div className='col-sm-5 col-md-4'>
                    {formscontents}
                </div>
            </div>
            <div className='row' id='tables_row'>
                <div className='col-md-12 col-lg-6'>
                    {myOrders}
                </div>
                <div className='col-md-12 col-lg-6'>
                    {myDeals}
                </div>
            </div>
        </div>;
    }
    //, instrumentAvail: DTO.InstrumentAvailabilityDto[]
    private renderInstruments(instruments: DTO.InstrumentHead[], instrumentsDS: DTO.AgentDSInstrumentGroup, tradesession?: DTO.TradeSessionDto) {
        var instrs = [];

        //console.log('Instruments: ' + instruments.length);

        const domset = instruments.map(inst =>
            <div key={inst.fiid} className="DoMClass">
                <DoMComponent iheader={inst} bookorders={[]} loading={true} holdFocus={false}
                    filterDS={instrumentsDS.instruments.filter((obj) => { return obj.fiid == inst.fiid })[0]}
                    //iavail={instrumentAvail.filter((obj) => { return obj.fiid == inst.fiid })[0]}
                    {...this.props} tradesession={tradesession} />
            </div>
        );

        return (
            <div className='grid-wrapper'>{domset}</div>
        )
    }

    private static renderForms(appstate: AppState, instruments: DTO.InstrumentHead[], currencies: DTO.Currency[], durations: DTO.Duration[], tradesession?: DTO.TradeSessionDto) {

        var norderf: DTO.NewOrder = {
            currency_id: instruments[0].currency.id,
            duration_id: instruments[0].duration.id,
            type: 'buy',
            rate: 0,
            discount: 0,
            sum: 0,
            minlot: 0,
            securityid: '',
            comment:''
        }

        const formscontent =
            <div className="FormsClass">
                <DoMRowDetailsComponent loading={false} user={Session.currentUser()} syshdr={appstate.syshdr} tradesession={tradesession} />
                <NewOrderComponent syshdr={appstate.syshdr} instruments={instruments} currencies={currencies} durations={durations} isLoading={false} seclookupoptions={[]} tradesession={tradesession} />
            </div>;

        return (
            <div>{formscontent}</div>
        )
    }

    private static renderMyOrders(orders: DTO.OrderBookRecords, myOrdersDS: DTO.AgentDSMyOrdersGroup, tradesession?: DTO.TradeSessionDto) {

        const myorderscontent =
            <div className="MyOrdersClass">
                <MyOrdersComponent records={[]} loading={true} ds={myOrdersDS} tradesession={tradesession} />
            </div>;


        return (
            //<div className='grid-wrapper'>{myorderscontent}</div>
            <div>{myorderscontent}</div>
        )

    }

    private static renderMyDeals(deals: DTO.OrderBookRecords, myDealsDS: DTO.AgentDSMyDealsGroup) {
        const mydealscontent =
            <div className="MyDealsClass">
                <MyDealsComponent records={[]} loading={true} ds={myDealsDS} showContragentInfo={false} />
            </div>;


        return (
            //<div className='grid-wrapper'>{mydealscontent}</div>
            <div>{mydealscontent}</div>
        )
    }

}



















//import * as React from 'react';
//import { RouteComponentProps } from 'react-router';
//import * as DTO from '../service/DTOs';
//import { AppState } from '../service/AppState';
//import { DoMComponent } from './DoM';
//import { MyOrdersComponent } from './MyOrders';
//import { MyDealsComponent } from './MyDeals';
//import { NewOrderComponent } from './OrderEntrance';
//import { DoMRowDetailsComponent } from './DoMRowDetails';
//import * as API from '../service/apisvc';
//import * as State from '../service/AppState';



//import * as TF from '../service/tradeflow';

//import 'isomorphic-fetch';

//export interface MainFrameState {
//    instruments: DTO.InstrumentHead[],
//    currencies: DTO.Currency[],
//    durations: DTO.Duration[],
//    appstate?: AppState,
//    sysavail: DTO.SystemOperationAvailabilityDto,
//    loading?: boolean;
//}

//type MainFrameProps = MainFrameState & { xsrfToken?: string } & RouteComponentProps<{}>;

//const initialstate: MainFrameState = {
//    instruments: [],
//    currencies: [],
//    durations: [],
//    appstate: undefined,
//    sysavail: State.default.sysavail,
//    loading: true
//}



//export class MainFrameComponent extends React.Component<MainFrameProps, MainFrameState> {
//    node_hb: HTMLDivElement | null;
//    constructor(props: MainFrameProps) {
//        super(props);
//        this.node_hb = null;
//        this.state = {
//            ...initialstate, ...{ instruments: props.instruments, appstate: props.appstate }
//        };



//        fetch(API.apiUrl(API.API_CONFIG_URL), {
//            method: 'GET',
//            credentials: 'include',
//            headers: new Headers({
//                ...{ 'X-XSRF-TOKEN': props.xsrfToken || '' },
//                ...API.authHeader()
//            })
//        })
//            .then(response => {
//                if (response.ok) {
//                    return response.json() as Promise<DTO.AppConfig>
//                } else {
//                    var cmd_hdr = response.headers.get(API._API_CMD_HEADER);
                    
//                    if (cmd_hdr) {
//                        TF.PublishSysCommand(cmd_hdr);
//                    }
//                    var error = new Error(response.statusText);
//                    throw error;
//                }
//              }
//            )
//            .then(data => {
//                this.setState({ instruments: data.instruments, currencies: data.currencies, durations: data.durations, loading: false });
//            })
//            .catch(reason => {
//                console.log(reason);
//            })
//            ;

//    }

//    processSysAvail(data: DTO.SystemOperationAvailabilityDto) {
//        if (this.refs.cmpNodeRef) {
//            this.setState({
//                sysavail: data
//            });
//        }

//        return { return: 0 };
//    }


//    componentDidMount() {
//        TF.DataProcessBinding(this, { type: 'SYS.updatesysavail', delegate: this.processSysAvail });

//        //if (window.tradeflow_binddata !== undefined) {
//        //    console.log(this.setApiHeaderResponse);

//        //    window.tradeflow_binddata(TF.TradeflowData.heartbeat, this, this.setApiHeaderResponse);
//        //}
        
        
//        //if (window.test !== undefined) {
//        //    window.test();
//        //}

//        //const testfn = window.test(); // eslint-disable-line        
//        //tradeflow.bind();
//    }

//    componentWillUnmount() {

//    }

//    public render() {
//        //console.log('this.state.appstate.dsctx.instrumentsDS');
//        //console.log(this.state.appstate ? this.state.appstate.dsctx.instrumentsDS : '');
        
        
//        //let s = State.default.dsctx.instrumentsDS.instruments.filter((obj) => { return obj.fiid ==  })
//        let DoMcontents = this.state.loading
//            ? <p><em>Loading...</em></p>
//            : this.renderInstruments(this.state.instruments,
//                this.state.appstate ? this.state.appstate.dsctx.instrumentsDS : State.default.dsctx.instrumentsDS,
//                //this.state.appstate ? this.state.appstate.sysavail.instruments : State.default.sysavail.instruments
//            );

//        let formscontents = this.state.loading
//            ? <p><em>Loading...</em></p>
//            : MainFrameComponent.renderForms(this.state.instruments, this.state.currencies, this.state.durations, this.state.sysavail.tradesession); 

//        let myOrders = this.state.loading
//            ? <p><em>Loading...</em></p>
//            : MainFrameComponent.renderMyOrders({ ordbook_records: [] }, this.state.appstate ? this.state.appstate.dsctx.myOrdersDS : { periodFilter: { isCurrentPeriod: true } }, this.state.sysavail.tradesession);

//        let myDeals = this.state.loading
//            ? <p><em>Loading...</em></p>
//            : MainFrameComponent.renderMyDeals({ ordbook_records: [] }, this.state.appstate ? this.state.appstate.dsctx.myDealsDS : { periodFilter: { isCurrentPeriod: true } });

//        //className='container'
//        return <div ref="cmpNodeRef" className={'otc-trade'}>
//            <div className='row' id='body_row'>
//                <div className='col-sm-8'>
//                    {DoMcontents}
//                </div>
//                <div className='col-sm-4'>
//                    {formscontents}
//                </div>
//            </div>
//            <div className='row' id='tables_row'>
//                <div className='col-sm-6'>
//                    {myOrders}
//                </div>
//                <div className='col-sm-6'>
//                    {myDeals}
//                </div>
//            </div>
//        </div>;
//    }
//    //, instrumentAvail: DTO.InstrumentAvailabilityDto[]
//    private renderInstruments(instruments: DTO.InstrumentHead[], instrumentsDS: DTO.AgentDSInstrumentGroup) {
//        var instrs = [];

//        //console.log('Instruments: ' + instruments.length);

//        const domset = instruments.map(inst =>
//            <div key={inst.fiid} className="DoMClass">
//                <DoMComponent iheader={inst} bookorders={[]} loading={true} holdFocus={false}
//                    filterDS={instrumentsDS.instruments.filter((obj) => { return obj.fiid == inst.fiid })[0]}
//                    //iavail={instrumentAvail.filter((obj) => { return obj.fiid == inst.fiid })[0]}
//                    {...this.props} />
//            </div>
//        );

//        return (
//            <div className='grid-wrapper'>{domset}</div>
//        )
//    }

//    private static renderForms(instruments: DTO.InstrumentHead[], currencies: DTO.Currency[], durations: DTO.Duration[], tradesession?: DTO.TradeSessionDto) {

//        var norderf: DTO.NewOrder = {
//            currency_id: instruments[0].currency.id,
//            duration_id: instruments[0].duration.id,
//            type: 'buy',
//            rate: 0,
//            discount: 0,
//            sum: 0,
//            minlot: 0,
//            securityid: '',
//            comment:''
//        }

//        const formscontent =
//            <div className="FormsClass">
//                <DoMRowDetailsComponent loading={false} />
//                <NewOrderComponent instruments={instruments} currencies={currencies} durations={durations} isLoading={false} seclookupoptions={[]} tradesession={tradesession} />
//            </div>;

//        return (
//            <div>{formscontent}</div>
//        )
//    }

//    private static renderMyOrders(orders: DTO.OrderBookRecords, myOrdersDS: DTO.AgentDSMyOrdersGroup, tradesession?: DTO.TradeSessionDto) {
        
//        const myorderscontent =
//            <div className="MyOrdersClass">
//                <MyOrdersComponent records={[]} loading={true} ds={myOrdersDS} tradesession={tradesession}/>
//            </div>;


//        return (
//            //<div className='grid-wrapper'>{myorderscontent}</div>
//            <div>{myorderscontent}</div>
//        )

//    }

//    private static renderMyDeals(deals: DTO.OrderBookRecords, myDealsDS: DTO.AgentDSMyDealsGroup) {
//        const mydealscontent =
//            <div className="MyDealsClass">
//                <MyDealsComponent records={[]} loading={true} ds={myDealsDS} showContragentInfo={false}/>
//            </div>;
        

//        return (
//            //<div className='grid-wrapper'>{mydealscontent}</div>
//            <div>{mydealscontent}</div>
//        )
//    }

//}
